<template>
  <v-container>
    <v-layout>
    <v-flex>
    <v-tooltip top >
      <v-btn
          class="mr-2 mb-2"
          @click="newMenu"
          color="customPurple"
          dark
          fixed
          bottom
          right
          fab
          slot="activator"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <span>Crear Menu</span>
    </v-tooltip>
      <div>
        <v-spacer></v-spacer>
        <v-layout>
          <v-flex xs12 sm6 offset-sm6>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
      <v-dialog
        v-model="dialog"
        max-width="500px"
        transition="dialog-bottom-transition"
        scrollable>
        <v-card tile>
          <v-toolbar card dark color="nav_background_color">
            <v-btn icon dark @click.native="dialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crear nuevo Menu</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout>
              <v-flex xs12 sm7 offset-sm1>
                <v-text-field
                  name="id"
                  label="Id"
                  id="code"
                  :rules="codeRules"
                  :counter="10"
                  required
                  v-model="menu.id"
                ></v-text-field>
              </v-flex>
            </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="title"
                    label="Título"
                    id="nombre"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="menu.title"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
               <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="icon"
                    label="Ícono"
                    id="icon"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="menu.icon"
                    required
                  ></v-text-field>
                </v-flex>
              </v-layout>
               <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="route"
                    label="Ruta"
                    id="route"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="menu.route"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm10 offset-sm1>
                  <v-text-field
                    name="description"
                    label="Descripción"
                    id="description"
                    :rules="[v => !!v || 'Es requerido',v => (v && v.length <= 50) || 'El número de caracteres debe ser menor a 50']"
                    v-model="menu.description"
                    required
                    v-on:keyup.enter="saveData"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex xs12 sm6 offset-sm4>
                  <div>
                    <v-btn :disabled="!valid"
                           @click="saveData"  large color= "primary">Guardar</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
    </v-layout>
       <h3 class="primary--text">Lista de Entidades</h3>
      <v-data-table
        :headers="headers"
        :items="$store.state.menus"
        class="elevation-1"
        sort-icon="mdi-menu-down"
        :search="search"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.id }}</td>
          <td class="text-xs-left">{{ props.item.icon }}</td>
          <td class="text-xs-left">{{ props.item.title }}</td>
          <td class="text-xs-left">{{ props.item.route }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td>
            <v-tooltip top >
              <v-btn 
              fab dark 
              small @click="editItem(props.item)" 
              slot="activator"
              color="primary">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <span>Editar</span>
            </v-tooltip>
            <v-tooltip top >
              <v-btn fab dark small @click="deleteItem(props.item)" slot="activator" color="primary">
                <v-icon dark>delete</v-icon>
              </v-btn>
            <span>Eliminar</span>
            </v-tooltip>
          </td>
        </template>

           
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
           No se han encontrado resultados para "{{ search }}".
        </v-alert>
      </v-data-table>
  </v-container>
</template>
<script>
import Menu from '../../model/Menu';

export default {
  data() {
    return {
      search: '',
      valid: false,
      codeRules: [
        v => !!v || 'El código es requerido',
        v =>
          (v && v.length <= 10) || 'El código debe tener menos de 10 caracteres'
      ],
      requiredField: [v => !!v || 'Es requerido'],
      dialog: false,
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Icono', value: 'icon' },
        { text: 'Título', value: 'title' },
        { text: 'Ruta', value: 'route' },
        { text: 'Descripción', value: 'editar' },
        { text: 'Acciones', value: 'editar' }

      ],
      editedIndex: -1,
      menu: new Menu()
    };
  },
  methods: {
    newMenu() {
      this.editedIndex = -1;
      this.dialog = true;
      this.valid = false;
      this.$refs.form.reset();
      this.menu = new Menu();
    },
    saveData() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          this.$store.dispatch('updateMenu', this.menu).then(response => {});
        } else {
          this.$store.dispatch('addMenu', this.menu).then(response => {});
        }
        this.dialog = false;
      }
    },
    editItem(item) {
      this.editedIndex = this.$store.state.menus.indexOf(item);
      this.menu = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.$store.state.menus.indexOf(item);
      this.menu = Object.assign({}, item);
      confirm('Está seguro de que quiere eliminar el registro?') &&
        this.$store.dispatch('deleteMenu', this.menu.id);
    }
  },
  computed: {},
  beforeCreate() {
    this.$store.dispatch('getMenus').then(
      response => {
      }
    );
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu/Menu.vue